import Task from "../../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import DebugToolsConnector from "./DebugToolsConnector";

export default class InitDebugToolsTask extends Task {

    constructor(injector, debugModuleList) {
        super();

        this.execute = (callback, progressCallback) => {
            //Connect debug tools
            if (ranj.DEBUG && debugModuleList != null && debugModuleList.length) {
                const debugToolsConnector = injector.createInstance(DebugToolsConnector);
                debugToolsConnector.configure();
                // Connect all modules, loading seperate modules can also be done with the "connectModule" method.
                debugToolsConnector.connectModules(debugModuleList);
            }
            
            //Task complete:
            callback(this);
        }
    }

}